import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import image1 from './logo/Pt. L.R.College of Technology (2).JPG'
import logoimage from '../images/HSBTE.webp'
import mdulogo from "../images/unnamed.png"
import { Link } from 'react-router-dom';
import Typed from 'typed.js';
import AOS from 'aos';
import 'aos/dist/aos.css'


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const typedElement = useRef(null); 
const [showLinks, setShowLinks] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
   
    const typed = new Typed(typedElement.current, {
      strings: ['Pandit L. R. College of Technology','Pt. L. R. College of Technology'],
      typeSpeed: 80, 
      backSpeed: 50,   
     backDelay: 50, 
       startDelay: 100, 
       loop:true,
      showCursor: false, 
      smartBackspace: true,
    });

   
    return () => {
      typed.destroy();
    };
  }, []);
 
  return (
    

    <div className="headersection1">
      <img className="image1" src={image1} alt="College Logo" />
     
    
      <div className="header-container">
        <div className="hamburger" onClick={toggleMenu}>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
        </div>

        <div className="college-name">
         <h1 ref={typedElement} className='element'></h1>  
          
        </div>
       
        <ul className={`menu-list ${isMenuOpen ? 'show' : ''}`}>
        
        <li className="list">
        <Link to="/Step" className="anchor">Online Admission 2025</Link>    
        </li>
<li className="list">
 {/* <Link to="/course" className="anchor">Course</Link>  */}
  <li><Link to="/Download" className="anchor">Download</Link></li>
</li>
{/* <li className="list">
<Link to="/All" className="anchor">Login</Link>

</li> */}
{/* <li className="list">
<Link to="/EnquiryForm" className="anchor">Enquiry</Link>
</li> */}

 {/* <li
      className="list"
      onMouseEnter={() => setShowLinks(true)}
      onMouseLeave={() => setShowLinks(false)}
    >
      <span className="anchor">Follow</span>
      {showLinks && (
        <div className="social-links">
          <a href="https://www.facebook.com/ptlrct" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://www.instagram.com/ptlrcollege?igsh=bnRteTRlNTNzZzVs" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://youtube.com/@ptlrgroupofinstitutionsfar7153?si=HloVCPGmhotcp17n" target="_blank" rel="noreferrer">YouTube</a>
          <a href="https://x.com/PTLRGROUP?t=BNjxxvkUKC3MIKt_rLzNxQ&s=09" target="_blank" rel="noreferrer">Twitter (X)</a>
        </div>
      )}
    </li> */}
 </ul>
 </div>
</div>
   
  );
};

export default Header;
